import type EnType from '../en-US/apiTest';

export default {
  'apiTestCase.messageError.praseError': 'Erro de Análise',
  'apiTestCase.messageError.csvFormatError': 'Não está em conformidade com o formato CSV',
  'apiTestCase.csvStandardRules': '《Especificação CSV Padrão》',
  'apiTestCase.report.statusCode': 'Status',
  'apiTestCase.report.statusLabel': 'Status HTTP: ',
  'apiTestCase.report.timeConsume': 'Tempo',
  'apiTestCase.report.TabSizeMap': 'Tamanho',
  'apiTest.label.actualRequest': 'Requisição Real',
  'apiText.response.timings.event': 'EVENTO',
  'apiText.response.timings.event.prepare': 'Preparação',
  'apiText.response.timings.event.socket': 'Inicialização do Socket',
  'apiText.response.timings.event.dns': 'Consulta DNS',
  'apiText.response.timings.event.tcp': 'Handshake TCP',
  'apiText.response.timings.event.ssl': 'Handshake SSL',
  'apiText.response.timings.event.transfer': 'Aguardando (TTFB)',
  'apiText.response.timings.event.download': 'Download do Conteúdo',
  'apiText.response.timings.event.process': 'Processamento',
  'apiText.response.timings.event.total': 'Total',
  'apiText.response.timings.timeLabel': 'TEMPO',
  'apiTest.debug.extension.install': 'Instalar',
  'apiTest.debug.extension.install.tips':
    'Por favor, instale a extensão de navegador {appName} para enviar requisições. Suporta apenas navegadores Chrome e Edge.',
  'apiText.response.error.message.fallback': 'Erro: {message}',
  'apiText.response.error.help': 'ajuda',
  'apiTest.debug.usedTemplateVar': 'A API usa variáveis de ambiente {variables}',
  'apiTest.debug.setTemplateVar': 'Por favor, defina as variáveis de ambiente {variables}',
  'apiTest.debug.toSetVar': 'Ir para definir valor',
  'apiTestCase.threadResources': 'Preparação de recursos de thread em andamento',
} satisfies typeof EnType;
